export default __webpack_public_path__ + "static/media/mentor_ship_plan.3c6ee444.png";